import React, {Fragment} from "react"
import PropTypes from "prop-types"
import {Col} from "react-bootstrap"
import {get} from "lodash"
import styled from "styled-components"

import {FormattedMessage} from "@irati/utils/lang"
import id from "@irati/utils/id"
import authentication from "@irati/auth"
import {H6} from "@irati/ui/src/Typography"

import DealResult from "../../../DealResult/DealResult"
import PerksNearMeResults from "./PerksNearMeResults"

const StyledCol = styled(Col)`
  margin-bottom: 45px;
`

const StyledDealResult = styled(DealResult)`
  margin-bottom: 10px;
`

const Deals = (props) => {
  const {results, onClick, maxResultsPerSection, searchTerm} = props
  const isGeoLocationEnabled = authentication.apps("platform.geoLocation")

  if (get(results, "data", 0).length === 0) {
    return null
  }

  return (
    <Fragment>
      <StyledCol md={isGeoLocationEnabled ? 6 : 12}>
        <H6 marginTop={-0.5} marginBottom={1}>
          <FormattedMessage id="perks.components.searchPopup.perksHeading" />
        </H6>
        {results.data.slice(0, maxResultsPerSection).map((deal) => (
          <StyledDealResult deal={deal} id={id(`deal__${deal.urlSlug}`, props)} key={`wrapper-${deal.uuid}`} onClick={onClick} />
        ))}
      </StyledCol>
      {isGeoLocationEnabled && (
        <StyledCol md={6}>
          <PerksNearMeResults searchTerm={searchTerm} />
        </StyledCol>
      )}
    </Fragment>
  )
}

Deals.propTypes = {
  results: PropTypes.shape({data: PropTypes.arrayOf(PropTypes.object)}),
  onClick: PropTypes.func,
  maxResultsPerSection: PropTypes.number,
  searchTerm: PropTypes.string.isRequired
}

Deals.defaultProps = {
  results: {},
  onClick: () => {},
  maxResultsPerSection: 5
}

export default Deals
